import { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useCustomTranslation } from 'hooks/useCustomTranslation'

export interface HeaderProps {
  isLoading: boolean
}

export const useHeader = (props: HeaderProps) => {
  const [scrolled, setScrolled] = useState(false)
  const [isMobileNavActive, setIsMobileNavActive] = useState(false)

  const { t } = useCustomTranslation()
  const location = useLocation()

  const toggleMobileNav = (toggle?: boolean) => {
    if (typeof toggle === 'boolean') setIsMobileNavActive(toggle)
    else setIsMobileNavActive(!isMobileNavActive)
  }

  const isHighlighted = (path: string) => {
    return location.pathname === path
  }

  useEffect(() => {
    if (window.scrollY > 0) {
      setScrolled(true)
    } else {
      setScrolled(false)
    }

    const handleScroll = () => {
      if (window.scrollY > 0) {
        setScrolled(true)
      } else {
        setScrolled(false)
      }
    }

    window.addEventListener('scroll', handleScroll)

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  return {
    ...props,
    scrolled,
    isMobileNavActive,
    isHighlighted,
    toggleMobileNav,
    t,
  }
}
